<template>
  <div class="container-fluid">
    <judging-navbar/>
    <div
      class="alert alert-warning d-sm-block d-md-none"
    >If can you see this message you are probably using a device with a small screen. The CAP Prize judging system has been designed to work with devices with screen sizes big enough to properly display the submitted work. You can view entries. You can not score them. We advise that you use a device with a screen resolution greater than 1024 x 768.</div>
    <table class="judges-review">
      <thead>
        <tr>
          <td>
            <div>
              <base-icon
                name="hash"
                stroke="rgba(100,100,100,1)"
                class="badge badge-pill badge-dark"
                width="16"
                height="16"
              >{{entryCount}}</base-icon>
            </div>
          </td>
          <td class="text-left">
            <div class="d-none d-md-block">
              <judging-filters/>
            </div>
          </td>
          <td class="d-none d-md-block">
            <span>
              <base-icon
                name="eye"
                stroke="rgba(100,100,100,1)"
                class="badge badge-pill badge-secondary"
                width="16"
                height="16"
              >{{seen}}</base-icon>
            </span>
            <span>
              <base-icon
                name="eye-off"
                stroke="rgba(100,100,100,1)"
                class="badge badge-pill badge-secondary"
                width="16"
                height="16"
              >{{unseen()}}</base-icon>
            </span>
          </td>
          <td colspan="2">
            <div class="d-none d-md-block">
              <span>
                <base-icon
                  name="custom-star"
                  stroke="rgba(100,100,100,1)"
                  class="badge badge-pill badge-secondary"
                  width="16"
                  height="16"
                >{{startedScoring}}</base-icon>
              </span>
              <span>
                <base-icon
                  name="octagon"
                  stroke="rgba(100,100,100,1)"
                  class="badge badge-pill badge-secondary"
                  width="16"
                  height="16"
                >{{zero}}</base-icon>
              </span>
              <span>
                <base-icon
                  name="circle"
                  stroke="rgba(100,100,100,1)"
                  class="badge badge-pill badge-secondary"
                  width="16"
                  height="16"
                >{{scored}}</base-icon>
              </span>
              <span>
                <base-icon
                  name="heart"
                  stroke="rgba(100,100,100,1)"
                  class="badge badge-pill badge-secondary"
                  width="16"
                  height="16"
                >{{loved}}</base-icon>
              </span>
            </div>
          </td>
          <td class="d-none d-md-block">
            <span>
              <base-icon
                name="message-square"
                stroke="rgba(100,100,100,1)"
                class="badge badge-pill badge-secondary"
                width="16"
                height="16"
              >{{commentCount}}</base-icon>
            </span>
          </td>
        </tr>
      </thead>
      <tbody>
        <router-link
          v-for="(entry, key, index)  in entries"
          :key="index"
          tag="tr"
          :to="{ name: 'judging-entry', params: { ceid: key, entry: entry, index: index} }"
        >
          <td v-if="entry.entry.photos" class="first-photo">
            <div
              :style="{background: 'url('+getFirstImage(entry.entry.photos)+')', backgroundSize: 'cover' }"
              class="clip"
              :class="clipClass(entry, currentJudge)"
            ></div>
          </td>
          <td v-if="entry.name" class="title-photographer">
            <span class="title">{{entry.entry.title | capitalize}}</span> by
            <span class="photographer">{{entry.name.toLowerCase() }}</span>
          </td>
          <td class="text-center d-none d-md-block">
            <base-icon name="eye" v-if="entry.scores[currentJudge].viewed"></base-icon>
          </td>

          <td class="text-right">
            <div class="px-3 dimensions d-none d-md-block">
              <div>{{ entry.scores[currentJudge].score.originality == -1 ? '' : 'originality '+ entry.scores[currentJudge].score.originality }}</div>
              <div>{{ entry.scores[currentJudge].score.resonance== -1 ? '' : 'resonance '+entry.scores[currentJudge].score.resonance }}</div>
              <div>{{ entry.scores[currentJudge].score.technical== -1 ? '' : 'technical '+entry.scores[currentJudge].score.technical }}</div>
              <div>{{ entry.scores[currentJudge].score.aesthetic == -1 ? '' : 'aesthetic '+entry.scores[currentJudge].score.aesthetic}}</div>
            </div>
          </td>
          <td>
            <span
              class="font-weight-bold"
            >{{ currentScore(entry.ceid)>-1 ? currentScore(entry.ceid) :'-'}}</span>
          </td>
          <td class="text-center d-none d-md-block">
            <base-icon name="message-square" v-if="entry.scores[currentJudge].comment.length > 0"></base-icon>
          </td>
        </router-link>
      </tbody>
    </table>
    <!-- LIST HEADINGS -->
    <!-- LIST -->
    <!-- entrant in entrants -->
    <svg width="0" height="0">
      <defs>
        <clipPath id="line-heart-clip">
          <polygon
            points="112 39 110 33 107 28 103 23 99 19 94 16 88 14 81 14 75 14 69 16 64 19 60 23 55 19 50 16 44 14 38 14 31 14 26 16 20 19 16 23 12 28 9 33 7 39 7 45 7 51 9 57 12 62 16 67 16 67 60 111 104 67 103 67 107 62 110 57 112 51 113 45 112 39 112 39"
          ></polygon>
        </clipPath>
        <clipPath id="heart-clip">
          <polygon points="60 23 103 67 60 111 16 67 60 23"></polygon>
          <circle cx="38" cy="45" r="31"></circle>
          <circle cx="81" cy="45" r="31"></circle>
        </clipPath>
        <clipPath id="circle-clip">
          <circle cx="60" cy="60" r="47"></circle>
        </clipPath>
        <clipPath id="stop-clip">
          <polygon points="79 15 41 15 15 41 15 79 41 105 79 105 105 79 105 41 79 15"></polygon>
        </clipPath>
        <clipPath id="romboid-clip">
          <polygon points="103 18 110 60 103 103 60 110 18 103 10 60 18 18 60 10 103 18"></polygon>
        </clipPath>
        <clipPath id="star-clip">
          <polygon
            points="99 76 115 59 99 43 99 20 76 20 60 4 43 20 20 20 20 43 4 59 20 76 20 99 43 99 60 115 76 99 99 99 99 76"
          ></polygon>
        </clipPath>
        <clipPath id="tile-clip">
          <circle cx="34" cy="33" r="18"></circle>
          <circle cx="87" cy="33" r="18"></circle>
          <circle cx="34" cy="87" r="18"></circle>
          <circle cx="87" cy="87" r="18"></circle>
          <rect x="20" y="20" width="78" height="78.39" transform="translate(-24 59) rotate(-45)"></rect>
        </clipPath>
        <clipPath id="line-tile-clip">
          <polygon
            points="115 59 101 45 105 33 87 15 75 19 60 4 45 19 34 15 15 33 19 45 4 59 19 75 15 87 34 105 45 101 60 115 74 100 87 105 105 87 100 74 115 59 115 59"
          ></polygon>
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import JudgingNavbar from '@/components/judging/JudgingNavbar.vue'
import JudgingFilters from '@/components/judging/JudgingFilters.vue'
export default {
  components: { JudgingNavbar, JudgingFilters },
  data() {
    return {
      someClass: true
    }
  },
  computed: {
    ...mapState({
      // entrants: state => state.admin.entrands
      entries: state => state.judging.entries,
      currentJudge: state => state.currentUser,
      isAdmin: state => state.judging.admin
    }),
    ...mapGetters({
      // entries: 'review/filteredEntries',
      entryCount: 'judging/entryCount',
      seen: 'judging/seen',
      startedScoring: 'judging/startedScoring',
      zero: 'judging/zero',
      scored: 'judging/scored',
      loved: 'judging/loved',
      currentScore: 'judging/currentScore',
      commentCount: 'judging/commentCount',
      allEntryArray: 'judging/allEntryArray'
    }),
    clipClass: () => (entry, currentJudge) => {
      // console.log(entry, currentJudge)
      const scoreArray = Object.values(entry.scores[currentJudge].score)
      const total = scoreArray.reduce((partial_sum, a) => partial_sum + a)
      const someClass = true
      if (scoreArray.includes(5) && !scoreArray.includes(-1)) {
        return { 'heart-clip': someClass }
      }
      if (total > 0 && !scoreArray.includes(-1)) {
        return { 'circle-clip': someClass }
      }
      if (total == 0 && !scoreArray.includes(-1)) {
        return { 'stop-clip': someClass }
      }
      if (scoreArray.includes(-1) && total > -4) {
        return { 'tile-clip': someClass }
      }
      if (entry.scores[currentJudge].viewed) {
        return { 'star-clip': someClass }
      }
      return { 'romboid-clip': someClass }
    }
  },
  methods: {
    getFirstImage(photoObject) {
      // console.log('photoObject:' + JSON.stringify(photoObject))
      let photoArray = Object.values(photoObject)
      // console.log(photoArray[0].galleryPath)
      return photoArray[0].galleryPath
    },
    unseen() {
      return this.allEntryArray.length - this.seen
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  mounted() {
    // this.getters.filteredEntries('period', '2016')
  }
}
</script>

<style lang="scss">
table.judges-review {
  width: 100%;
  thead td {
    text-align: center;
  }
  tbody tr {
    background-image: radial-gradient(ellipse at bottom, #eeeeee 0%, white 80%);
    cursor: pointer;
  }
  td.first-photo {
    width: 120px;
  }
  .title-photographer {
    font-weight: 200;
    .title,
    .photographer {
      text-transform: capitalize;
    }
    .title {
      font-weight: 400;
      font-size: 1.15em;
    }
  }
}

.dimensions div {
  font-size: 0.8em;
  font-weight: 200;
  font-style: italic;
}

.badge.badge-secondary {
  background-color: #969696;
}
.badge.badge-dark {
  background-color: #000000;
}
.badge .icon {
  stroke: rgba(255, 255, 255, 1);
}
.clip {
  width: 120px;
  height: 120px;
  background-position: 50% 50%;
  background-size: cover;
}

.heart-clip {
  clip-path: url(#heart-clip);
  -webkit-clip-path: url(#line-heart-clip);
}
.circle-clip {
  clip-path: url(#circle-clip);
  -webkit-clip-path: url(#circle-clip);
}
.stop-clip {
  clip-path: url(#stop-clip);
  -webkit-clip-path: url(#stop-clip);
}
.romboid-clip {
  clip-path: url(#romboid-clip);
  -webkit-clip-path: url(#romboid-clip);
}
.tile-clip {
  clip-path: url(#tile-clip);
  -webkit-clip-path: url(#line-tile-clip);
}
.star-clip {
  clip-path: url(#star-clip);
  -webkit-clip-path: url(#star-clip);
}

@media (min-width: 768px) {
  td.d-md-block {
    display: table-cell !important;
  }
}
</style>
